import styled from 'styled-components';

export const ModalTitle = styled.h4`
color: #083F44;
font-family: "Jost", sans-serif; 
font-size:20px;
font-weight: 600;
line-height: 30px;
text-align: center;
margin-top: 30px;
margin-bottom:20px;
 
`;
export const ModalButton = styled.div`
    display: flex;
    gap:30px;
    justify-content: center;
    margin-top: 20px;

    @media screen and (max-width: 480px){
        flex-direction: column;
        row-gap: 15px;
        padding: 0 20px;
    }
`;

export const ModalSmallText = styled.div`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    margin-bottom: 10px;
    padding: 0 0px 0 45px;
    @media screen and (max-width:575px) { 
    padding: 0;
    }
  
`;
export const AddressText = styled.p`
    color: #01606F;
    font-family: "Jost", sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    margin-bottom: 0px;
   
  
`;

export const ModalImage = styled.div`
text-align: center;
 img{
    width:auto !important;
 }


`;